import React, { useState } from 'react';
import { Link } from 'gatsby';

const links = [
  { href: '/', label: 'Home' },
  { href: '/poems', label: 'Poems' },
  { href: '/biography', label: 'Biography' },
  { href: '/published-work', label: 'Published Work' },
  { href: '/e-books', label: 'E-books' },
];

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="site-nav">
      <div className="nav-inner">

        {/* Hamburger button — small screens only */}
        <div className="nav-hamburger-wrap">
          <button
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
            className="nav-hamburger"
          >
            <span className={`nav-bar ${open ? 'bar-top-open' : ''}`} />
            <span className={`nav-bar ${open ? 'bar-mid-open' : ''}`} />
            <span className={`nav-bar ${open ? 'bar-bot-open' : ''}`} />
          </button>
        </div>

        {/* Mobile dropdown */}
        {open && (
          <ul className="nav-mobile">
            {links.map(({ href, label }) => (
              <li key={href}>
                <Link
                  to={href}
                  className="nav-mobile-link"
                  onClick={() => setOpen(false)}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        )}

        {/* Desktop nav */}
        <ul className="nav-desktop">
          {links.map(({ href, label }) => (
            <li key={href}>
              <Link to={href} className="nav-desktop-link">
                {label}
              </Link>
            </li>
          ))}
        </ul>

      </div>
    </nav>
  );
}
